<template>
  <el-dialog
    class="dialog"
    title="查看成绩"
    fullscreen
    :visible.sync="dialogVisible"
    v-if="dialogVisible"
    :close-on-click-modal="true"
    :close-on-press-escape="false"
    destroy-on-close
  >
    <div>
      <div class="exam-title">试卷名称：{{ examPaperInfo.paperName }}</div>
      <div class="exam-score">(满分：{{ examPaperInfo.totalScore }}分)</div>
      <div class="info-date">提交时间：{{ examPaperInfo.examEndTime }}</div>
      <table>
        <tr>
          <th class="t-head">得分</th>
          <th class="t-head">答对</th>
          <th class="t-head">答错</th>
        </tr>
        <tr>
          <th class="t-body">{{ examPaperInfo.examScore }}</th>
          <th class="t-body">{{ examPaperInfo.rightNum }}</th>
          <th class="t-body">{{ examPaperInfo.wrongNum }}</th>
        </tr>
      </table>
    </div>
    <div class="paper">
      <template v-if="examPaperInfo.singleQstCount > 0">
        <div class="exam-category">
          单选题(每题{{ examPaperInfo.singleQstScore }}分,共{{
            examPaperInfo.singleQstCount
          }}题)
        </div>
        <questions
          :datas="examPaperInfo.singleQstList"
          type="result"
        ></questions>
      </template>
      <template v-if="examPaperInfo.multipleQstCount > 0">
        <div class="exam-category">
          多选题(每题{{ examPaperInfo.multipleQstScore }}分,共{{
            examPaperInfo.multipleQstCount
          }}题)
        </div>
        <questions
          multiple
          :datas="examPaperInfo.multipleQstList"
          type="result"
        ></questions>
      </template>
      <template v-if="examPaperInfo.judgeQstCount > 0">
        <div class="exam-category">
          判断题(每题{{ examPaperInfo.judgeQstScore }}分,共{{
            examPaperInfo.judgeQstCount
          }}题)
        </div>
        <questions
          :datas="examPaperInfo.judgeQstList"
          type="result"
        ></questions>
      </template>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="dialogVisible = false" size="small"
        >关闭</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import vue from "@/main";
import { getExamBatch } from "@/api/examInfo";
import Questions from "@/views/questions";
export default {
  components: {
    Questions
  },
  data() {
    return {
      dialogVisible: false,
      examPaperInfo: {}
    };
  },
  created() {
    vue.$on("previewExamScore", id => {
      this.dialogVisible = true;
      getExamBatch(id).then(res => {
        if (!res || res.code != 0) return;
        let obj = Object.assign({}, res.data);
        if (obj.singleQstList) {
          obj.singleQstList.map(ele => {
            ele["correctAnswer"] = ele.correctOptionNoList.join();
            ele["userAnswer"] = ele.chooseOptionNoList && ele.chooseOptionNoList.join();
            return ele;
          });
        }
        if (obj.judgeQstList) {
          obj.judgeQstList.map(ele => {
            ele["correctAnswer"] = ele.correctOptionNoList.join();
            ele["userAnswer"] = ele.chooseOptionNoList && ele.chooseOptionNoList.join();
            return ele;
          });
        }
        if (obj.multipleQstList) {
          obj.multipleQstList.map(ele => {
            ele["correctAnswer"] = ele.correctOptionNoList;
            ele["userAnswer"] = ele.chooseOptionNoList;
            return ele;
          });
        }
        this.examPaperInfo = obj;
      });
    });
  },
  watch: {
    examPaperInfo() {
      this.$nextTick(() => {
        let doms = document.getElementsByClassName("exam-category");
        for (let index = 0; index < doms.length; index++) {
          const element = doms[index];
          element.innerText =
            this.mapNum2Chinese(index + 1) + "、" + element.innerText;
        }
      });
    }
  },
  beforeDestroy() {
    vue.$off("addScore");
  },
  methods: {
    mapNum2Chinese(num) {
      switch (num) {
        case 1:
          return "一";
        case 2:
          return "二";
        case 3:
          return "三";
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
$color: #343c4a;
$text-size: 14px;
.dialog {
  /deep/ .el-dialog.is-fullscreen {
    overflow: hidden;
  }
  /deep/ .el-dialog__body {
    max-height: calc(100% - 117px);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 10px 20px;
  }
  .exam-title {
    font-size: 20px;
    color: $color;
    text-align: center;
  }
  .exam-score {
    font-size: $text-size;
    color: $color;
    text-align: center;
    margin: 10px 0;
  }
  .info-date {
    display: block;
    margin-top: 10px;
    color: #96a1b2;
    font-size: 14px;
  }
  table {
    border-collapse: collapse;
    margin: 10px 0;
  }
  table,
  th {
    border: 1px solid #d7dbe0;
  }
  th {
    padding: 10px 20px;
    &.t-head {
      color: #96a1b2;
      font-size: $text-size;
    }
    &.t-body {
      color: $color;
      font-size: $text-size;
    }
  }
  .paper {
    flex: 1;
    overflow: auto;
    .exam-category {
      font-size: 15px;
      font-weight: 500;
      color: $color;
    }
  }
  .dialog-footer {
    text-align: center;
  }
}
</style>
